import React, { useState } from 'react';

const ModernSlaveryStatement = () => {
  return (
    <div className="legal-page" style={{ backgroundColor: '#f4f6f8', paddingBottom: '6rem' }}>
      
      {/* INJECTED STYLES TO HIDE GLOBAL ARROWS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .legal-hero::after {
            display: none !important;
          }
        `}
      </style>

      {/* Unified Hero */}
      <section className="legal-hero">
        <div className="container text-center">
          <h1>Modern Slavery Statement</h1>
          <p className="subtitle">
            Our commitment to ethical operations and the eradication of forced labour.
          </p>
        </div>
      </section>

      {/* Legal Content (Floating Document Card) */}
      <section className="legal-content container" style={{ position: 'relative', marginTop: '-80px', zIndex: 10 }}>
        <div className="legal-text-block" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 8%', borderRadius: '16px', boxShadow: '0 20px 50px rgba(0,0,0,0.08)' }}>
          
          <div style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', paddingBottom: '1.5rem', marginBottom: '3rem' }}>
            <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)' }}>
              Published pursuant to Section 54 of the Modern Slavery Act 2015.
            </p>
          </div>

          <h2>1. Organisational Structure and Supply Chains</h2>
          <p>
            Nightmark Protective Services is a premium security provider operating across the United Kingdom. We supply Close Protection, Static Guarding, Risk Consultancy and Remote Monitoring services to corporate, private and public sector clients. Our supply chains primarily consist of uniform suppliers, technology vendors and specialised vehicle providers based within the UK and Europe.
          </p>

          <h2>2. Our Policy on Modern Slavery and Human Trafficking</h2>
          <p>
            We have a zero-tolerance approach to modern slavery, forced labour and human trafficking. We are committed to acting ethically and with integrity in all our business dealings and relationships. We consistently implement and enforce effective systems and controls to ensure modern slavery is not taking place anywhere in our own business or in any of our supply chains.
          </p>

          <h2>3. Due Diligence and Vetting (BS7858)</h2>
          <p>
            The security industry inherently requires strict personnel verification. Nightmark Protective Services mitigates the risk of modern slavery internally through our rigorous recruitment processes:
          </p>
          <ul className="legal-list">
            <li>All personnel are subjected to strict BS7858 vetting prior to deployment.</li>
            <li>We mandate verified right-to-work checks, 5-year employment history tracing and proof of address.</li>
            <li>All operatives must hold valid SIA licences, independently verified by the Security Industry Authority.</li>
            <li>Wages are paid strictly into bank accounts registered directly to the employee.</li>
          </ul>

          <h2>4. Supplier Adherence</h2>
          <p>
            We expect all our contractors, suppliers and other business partners to uphold the same high standards. As part of our contracting processes, we include specific prohibitions against the use of forced, compulsory or trafficked labour. We reserve the right to terminate relationships with any supplier found to be in breach of these obligations.
          </p>

          <h2>5. Ongoing Commitment</h2>
          <p>
            This statement represents our commitment for the current financial year. We will continuously review our recruitment procedures, supplier due diligence and staff training to ensure we maintain our robust stance against modern slavery.
          </p>
          
          <div style={{ marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
            <p style={{ margin: 0, fontStyle: 'italic', color: 'var(--color-primary-navy)', fontWeight: '600' }}>
              Approved by the Board of Directors, Nightmark Protective Services.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default ModernSlaveryStatement;